import { FormattedMessage } from 'react-intl';
import { Button } from 'antd';
import moment from 'moment';

import { IWalletCashOut, IWalletCashOutBrand } from '@share/common-types';

import { CashOutStatus } from '../cash-out-status';

import './style.scss';

interface IProps {
  cashOuts: IWalletCashOut[];
  brands: IWalletCashOutBrand[];
  formatPoints: (value: number) => string;
  formatMoney: (value: number, currency: string) => string;
  onView: (cashOutCode: string) => void;
}

export function CashOutHistory(props: IProps) {
  const { cashOuts, brands, formatPoints, formatMoney, onView } = props;

  if (!cashOuts.length) {
    return null;
  }

  const brandName = (productId?: string | null) =>
    brands.find((b) => b.productId === productId)?.name ?? productId ?? '—';

  return (
    <div className="cash-out-history">
      <h3 className="cash-out-history__title">
        <FormattedMessage id="wallet.cashout.history.title" />
      </h3>

      <ul className="cash-out-history__list">
        {cashOuts.map((cashOut) => (
          <li key={cashOut.cashOutCode} className="cash-out-history__item">
            <div className="cash-out-history__main">
              <span className="cash-out-history__brand">{brandName(cashOut.productId)}</span>
              <span className="cash-out-history__date">
                {moment(cashOut.createdAt).format('MM/DD/YYYY')}
              </span>
            </div>
            <div className="cash-out-history__amounts">
              <span>{formatMoney(cashOut.payoutAmount, cashOut.currencyCode)}</span>
              <span className="cash-out-history__points">
                <FormattedMessage
                  id="wallet.cashout.history.debited"
                  values={{ points: formatPoints(cashOut.pointsDebited) }}
                />
              </span>
            </div>
            <CashOutStatus status={cashOut.status} />
            <Button type="link" onClick={() => onView(cashOut.cashOutCode)}>
              <FormattedMessage id="wallet.cashout.history.view" />
            </Button>
          </li>
        ))}
      </ul>
    </div>
  );
}
